import ApiService from '@/core/services/ApiService';
import { Storage } from '@/core/helpers/Storage';
import { Encryption } from '@/core/helpers/Encryption';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Endpoints } from '@/api/ApiEndpoints';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';
import router from '@/router';

@Module
export default class DynamicFilterModule extends VuexModule {
	filterValues = {};
	appliedFilterValues = {};
	dataForFilters = {};
    
	@Action({ rawError: true })
	[Actions.CLEAR_FILTER_MODULE]() {
		this.context.commit(Mutations.CLEAR_FILTER_MODULE);
	}
	@Action({ rawError: true })
	[Actions.INITIALIZE_FILTER_VALUES](payload) {
		
		this.context.commit(Mutations.RESET_APPLIED_FILTERS,{key:payload.key});
		const filters = this.context.getters.getFiltersMapping({key:payload.key});
		const initialFilters = this.context.getters.getInitialFiltersMapping({key:payload.key});
		
		const queryParams = router.currentRoute.value.query;
		
		if(initialFilters){
		
			this.context.commit(Mutations.SET_INITIAL_FILTERS_VALUES,{key:payload.key,filterValues:initialFilters});	
			
			this.context.commit(Mutations.SET_APPLIED_FILTERS_VALUES,{key:payload.key,filterValues:initialFilters});
			
			filters.forEach( async(filter) => {
				if (filter.endpoint) {
					
				
					if(!payload.isResetFilters){
						const response = await ApiService.get(filter.endpoint);
						this.context.commit(Mutations.SET_DATA_FOR_FILTER_VALUES, { key:payload.key ,attrKey: filter.name, data: response.data});
					}
						
				} 
			});

			// Override initial filters with query params if provided
			if(!payload.isResetFilters && filters){
				filters.forEach((filter) => {
					if(queryParams[filter.name]){
						const paramValue = queryParams[filter.name];
						const paramText = queryParams[filter.name+"_text"] ?? paramValue ?? '';
						const isDate = filter.type === 'date';
						const isRadioStatic = filter.type === 'radioButtonWithStaticValues';
						const isBoolRadio = filter.type === 'radioButton';
						this.context.commit(Mutations.SET_FILTERS_VALUE, { key:payload.key ,attrKey: filter.name, value: paramValue,valueText:paramText, nullable:isDate, type: isRadioStatic ? 'radio' : (isBoolRadio ? 'bool' : 'object')});
						this.context.commit(Mutations.SET_APPLIED_FILTER_VALUE, { key:payload.key ,attrKey: filter.name, value: paramValue,valueText:paramText, nullable:isDate, type: isRadioStatic ? 'radio' : (isBoolRadio ? 'bool' : 'object')});
					}
				});
			}
				

		} 
		else{
			
			if(filters){
				filters.forEach( async(filter) => {
					
					if (filter.endpoint) {
						
						this.context.commit(Mutations.SET_FILTERS_VALUE, { key:payload.key ,attrKey: filter.name });
						if(!payload.isResetFilters){
							const response = await ApiService.get(filter.endpoint);
							this.context.commit(Mutations.SET_DATA_FOR_FILTER_VALUES, { key:payload.key ,attrKey: filter.name, data: response.data});
							
						}
						
					} 
					
					
				});	
				filters.forEach( async(filter) => {
					if (filter.endpoint) {
						
						this.context.commit(Mutations.SET_FILTERS_VALUE, { key:payload.key ,attrKey: filter.name });
						if(!payload.isResetFilters){
							if(queryParams[filter.name]){
								const paramValue = queryParams[filter.name];
								const paramText = queryParams[filter.name+"_text"] ?? paramValue ?? '';
								this.context.commit(Mutations.SET_FILTERS_VALUE, { key:payload.key ,attrKey: filter.name, value: paramValue,valueText:paramText});
								this.context.commit(Mutations.SET_APPLIED_FILTER_VALUE, { key:payload.key ,attrKey: filter.name, value: paramValue,valueText:paramText});
							}
						}
						
					} 
					else{
						if(filter.type == 'date'){
							this.context.commit(Mutations.SET_FILTERS_VALUE, { key:payload.key ,attrKey: filter.name, nullable:true, });
							if(queryParams[filter.name]){
								const paramValue = queryParams[filter.name];
								const paramText = queryParams[filter.name+"_text"] ?? paramValue ?? '';
								this.context.commit(Mutations.SET_FILTERS_VALUE, { key:payload.key ,attrKey: filter.name, nullable:true,value: paramValue,valueText:paramText});
								this.context.commit(Mutations.SET_APPLIED_FILTER_VALUE, { key:payload.key ,attrKey: filter.name, nullable:true,value: paramValue,valueText:paramText});
							}
						}
						else{
						
							this.context.commit(Mutations.SET_FILTERS_VALUE, { key:payload.key ,attrKey: filter.name });
							if(queryParams[filter.name]){
								const paramValue = queryParams[filter.name];
								const paramText = queryParams[filter.name+"_text"] ?? paramValue ?? '';
								this.context.commit(Mutations.SET_FILTERS_VALUE, { key:payload.key ,attrKey: filter.name,value: paramValue,valueText:paramText});
								this.context.commit(Mutations.SET_APPLIED_FILTER_VALUE, { key:payload.key ,attrKey: filter.name,value: paramValue,valueText:paramText});
							}
						}
					}
				})
				
				
				
				if(payload.isResetFilters){
					this.context.dispatch(Actions.GET_DYNAMIC_LIST,{key: payload.key, page: 1});
				}
			}
		}
		
	}

	@Action({ rawError: true })
	[Actions.SET_APPLIED_FILTERS_VALUES](payload) {
		this.context.commit(Mutations.SET_APPLIED_FILTERS_VALUES, {key: payload.key , filterValues: this.filterValues[payload.key]});
		this.context.dispatch(Actions.GET_DYNAMIC_LIST,{key: payload.key, page: 1});
	}


	@Action({ rawError: true })
	[Actions.CLEAR_FILTER_TAG](payload) {
		this.context.commit(Mutations.CLEAR_FILTER_TAG,{...payload,key: payload.key});
		this.context.dispatch(Actions.GET_DYNAMIC_LIST,{key: payload.key, page: 1});
	}
	@Action({ rawError: true })
	[Actions.SET_FILTERS_VALUE](payload) {
		this.context.commit(Mutations.SET_FILTERS_VALUE,payload);		
	}

	@Mutation
	[Mutations.RESET_APPLIED_FILTERS](payload) {
		this.appliedFilterValues[payload.key] = {};
	}
	@Mutation
	[Mutations.CLEAR_FILTER_TAG](payload) {
		this.filterValues[payload.key][payload.attrKey] = {};
		this.appliedFilterValues[payload.key][payload.attrKey] = {};
	}

	@Mutation
	[Mutations.SET_FILTERS_VALUE](payload) {
		
		if(!this.filterValues[payload.key]){
			this.filterValues[payload.key] = {};
		}
		this.filterValues[payload.key][payload.attrKey] = {};
        this.filterValues[payload.key][payload.attrKey]['value'] = (payload.value!=null)?payload.value:(payload.nullable)?null:'';
        this.filterValues[payload.key][payload.attrKey]['valueText'] = (payload.valueText)?payload.valueText:'';		
        this.filterValues[payload.key][payload.attrKey]['type'] = (payload.type)?payload.type:'object';		
        this.filterValues[payload.key][payload.attrKey]['clear'] = (payload.clear)?payload.clear:null;		
		
	}
	@Mutation
	[Mutations.SET_APPLIED_FILTERS_VALUES](payload) {

		this.appliedFilterValues[payload.key] = {...payload.filterValues};
		
		
	}
	@Mutation
	[Mutations.SET_APPLIED_FILTER_VALUE](payload) {
		
		if(!this.appliedFilterValues[payload.key]){
			this.appliedFilterValues[payload.key] = {};
		}
		this.appliedFilterValues[payload.key][payload.attrKey] = {};
        this.appliedFilterValues[payload.key][payload.attrKey]['value'] = (payload.value!=null)?payload.value:(payload.nullable)?null:'';
        this.appliedFilterValues[payload.key][payload.attrKey]['valueText'] = (payload.valueText)?payload.valueText:'';		
        this.appliedFilterValues[payload.key][payload.attrKey]['type'] = (payload.type)?payload.type:'object';		
        this.appliedFilterValues[payload.key][payload.attrKey]['clear'] = (payload.clear)?payload.clear:null;		
		
		
	}
	@Mutation
	[Mutations.SET_INITIAL_FILTERS_VALUES](payload) {
		
		this.filterValues[payload.key] = payload.filterValues;
		
	}
	@Mutation
	[Mutations.SET_DATA_FOR_FILTER_VALUES](payload) {
		if(!this.dataForFilters[payload.key]){
			this.dataForFilters[payload.key] = {};
		}
		this.dataForFilters[payload.key][payload.attrKey] = payload.data;
	}
	@Mutation
	[Mutations.CLEAR_FILTER_MODULE](payload) {
		this.filterValues = {};
		this.appliedFilterValues = {};
		this.dataForFilters = {};
	}


	get getFilterValues() {
		return (payload) => {
			return this.filterValues[payload.key];
		}
	}
	get getDateForFilters() {
		return (payload) => {
			return this.dataForFilters[payload.key];
		}
	}
	
	get getAppliedFilterValues() {
		return (payload) => {
			return this.appliedFilterValues[payload.key] || {};
		}
	}
	
}
